<template>
  <div class="vue-csv-uploader">
    <div class="form">
      <div class="vue-csv-uploader-part-one">
        <div class="form-group csv-import-file">
          <input ref="csv" type="file" :class="inputClass" name="csv" v-on:input="submit" v-on:change="submit">
          <div class="invalid-feedback d-block" v-if="showErrorMessage">
            File type is invalid
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: Array,
    url: {
      type: String
    },
    mapFields: {
      required: true
    },
    callback: {
      type: Function,
      default: () => {
      }
    },
    catch: {
      type: Function,
      default: () => {
      }
    },
    finally: {
      type: Function,
      default: () => {
      }
    },
    parseConfig: {
      type: Object,
      default() {
        return {};
      }
    },
    headers: {
      default: null
    },
    loadBtnText: {
      type: String,
      default: "Next"
    },
    submitBtnText: {
      type: String,
      default: "Submit"
    },
    tableClass: {
      type: String,
      default: "table"
    },
    checkboxClass: {
      type: String,
      default: "form-check-input"
    },
    buttonClass: {
      type: String,
      default: "btn btn-primary"
    },
    inputClass: {
      type: String,
      default: "form-control-file"
    }
  },

  data: () => ({
    form: {
      csv: null,
    },
    csv: null,
    showErrorMessage: false
  }),

  methods: {
    submit() {
      const _this = this;
      let file = this.$refs.csv.files[0];
      if (file) {
        if (!this.isCorrectFileType(file.name)) {
          this.showErrorMessage = true;
        }
        else {
          let reader = new FileReader();
          reader.readAsText(file, "UTF-8");
          reader.onload = function (evt) {
            _this.csv = evt.target.result;
            _this.csv = _this.csv.replace(/barcode/i,'').replace(/[\r\",]/g, '').split('\n');
            _this.csv = _this.csv.filter(s => s);
            _this.$emit('input', _this.csv);
          };
          reader.onerror = function () {
          };
        }
      }
    },
    getFileExtension(filename) {
      const parts = filename.split('.');
      return parts[parts.length - 1];
    },
    isCorrectFileType(filename) {
      const fileType = this.getFileExtension(filename);
      return fileType === 'csv';
    }
  }
};
</script>
